var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 13.3335C9.41441 13.3335 10.771 12.7716 11.7712 11.7714C12.7713 10.7712 13.3333 9.41465 13.3333 8.00016C13.3333 6.58567 12.7713 5.22912 11.7712 4.22893C10.771 3.22873 9.41441 2.66683 7.99992 2.66683C6.58543 2.66683 5.22888 3.22873 4.22868 4.22893C3.22849 5.22912 2.66659 6.58567 2.66659 8.00016C2.66659 9.41465 3.22849 10.7712 4.22868 11.7714C5.22888 12.7716 6.58543 13.3335 7.99992 13.3335ZM7.99992 1.3335C8.8754 1.3335 9.7423 1.50593 10.5511 1.84097C11.36 2.176 12.0949 2.66706 12.714 3.28612C13.333 3.90517 13.8241 4.6401 14.1591 5.44894C14.4941 6.25778 14.6666 7.12468 14.6666 8.00016C14.6666 9.76827 13.9642 11.464 12.714 12.7142C11.4637 13.9644 9.76803 14.6668 7.99992 14.6668C4.31325 14.6668 1.33325 11.6668 1.33325 8.00016C1.33325 6.23205 2.03563 4.53636 3.28587 3.28612C4.53612 2.03587 6.23181 1.3335 7.99992 1.3335ZM8.33325 4.66683V8.16683L11.3333 9.94683L10.8333 10.7668L7.33325 8.66683V4.66683H8.33325Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.0e605b5e8601de9cac8d44bc664f612a.svg";
export { ForwardRef as ReactComponent };